import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import ReceiptPushFailed from 'ext-ui/svg/icon/ReceiptPushFailed'
import React from 'react'
import QuickBooks from 'src/assets/images/QuickBooks.svg'
import SvgNetSuiteIcon from 'src/components/Svgs/SvgNetSuiteIcon'
import SvgTransactionPushPending from 'src/components/Svgs/SvgTransactionPushPending'
import { OrganizationConnectedPlatform } from 'src/enums'
import { useTranslate } from 'src/localization/Trns'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface ReceiptPushStatusTooltipProps {
  className?: string
  openLeft: boolean
  status: ConnectedPlatformStatus | undefined
  platform: OrganizationConnectedPlatform | undefined
}

const ReceiptPushStatusTooltip: React.FC<ReceiptPushStatusTooltipProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const iconForStatus = (
    status: ConnectedPlatformStatus | undefined,
  ): React.ReactElement | undefined => {
    switch (status) {
      case ConnectedPlatformStatus.Pending: {
        return (
          <SvgTransactionPushPending data-testid={'erpReceiptSyncInProgress'} />
        )
      }
      case ConnectedPlatformStatus.Failed: {
        return <ReceiptPushFailed data-testid={'erpReceiptSyncFailed'} />
      }
      case ConnectedPlatformStatus.Success: {
        switch (props.platform) {
          case OrganizationConnectedPlatform.NETSUITE: {
            return <SvgNetSuiteIcon data-testid={'erpReceiptSyncSuccess'} />
          }
          case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE_SANDBOX:
          case OrganizationConnectedPlatform.QUICKBOOKS_DESKTOP:
          case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE: {
            return (
              <img
                src={QuickBooks}
                css={css`
                  transform: scale(0.6);
                `}
                alt={''}
                data-testid={'erpReceiptSyncSuccess'}
              />
            )
          }
        }
        break
      }
      case ConnectedPlatformStatus.NotSynced:
      default: {
        return undefined
      }
    }
  }

  const tooltipForStatus = (
    status: ConnectedPlatformStatus | undefined,
  ): string | undefined => {
    switch (status) {
      case ConnectedPlatformStatus.Pending: {
        return translate('Attachment sync in progress')
      }
      case ConnectedPlatformStatus.Failed: {
        return translate('Attachment failed to sync')
      }
      case ConnectedPlatformStatus.Success: {
        return translate('Attachment synced')
      }
      case ConnectedPlatformStatus.NotSynced:
      default: {
        return undefined
      }
    }
  }

  // dont show tooltip if no icon
  if (iconForStatus(props.status) === undefined) {
    return <></>
  }

  return (
    <TooltipIcon
      className={props.className}
      placement={props.openLeft ? 'left' : 'right'}
      icon={iconForStatus(props.status)}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          height: 16px;
        `}
      >
        <p>{tooltipForStatus(props.status)}</p>
      </div>
    </TooltipIcon>
  )
}

export default ReceiptPushStatusTooltip
